// src/dashboard/reducers/catalog.js
import {
  FETCH_CATALOG_REQUEST,
  FETCH_CATALOG_SUCCESS,
  FETCH_CATALOG_FAILURE,
} from "../actions/catalog";

const initialState = { data: [], status: "idle", error: null, fetchedAt: 0 };

export default function catalogReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_CATALOG_REQUEST:
      return { ...state, status: "loading", error: null };
    case FETCH_CATALOG_SUCCESS:
      return { data: action.payload.data, status: "success", error: null, fetchedAt: Date.now() };
    case FETCH_CATALOG_FAILURE:
      return { ...state, status: "error", error: action.payload.error };
    default:
      return state;
  }
}
